<template>
  <div class="wrap">

    <div class="scroll-wrap">
        <ul class="scroll-content" :style="{ top }">
          <li  v-for="item in params.list" 
            :key="item.id">
            <span class="el-icon-s-comment"></span>
            {{item.title}}
          </li >
        </ul>
    </div>

  </div>
</template>

<script>
export default {
  props: {
    params: {
      type: [Object, Array]
    }
  },
  data() {
    return {
      activeIndex: 0
    }
  },
  computed: {
    top() {
      return - this.activeIndex * 40 + 'px';
    }
  },
  created() {

    if(this.params.list.length > 1) {
      setInterval(_ => {
        if(this.activeIndex < this.params.list.length - 1) {
          this.activeIndex += 1;
        } else {
          this.activeIndex = 0;
        }
      }, 3000);
    }
  }

}
</script>

<style lang="scss" scoped>
.el-icon-s-comment{
  color: #e7442f;
  font-size: 26px;
  margin-right: 10px;
}
.wrap{
  padding: 10px 10px;
}

.scroll-wrap{
  width: 400px;
  height: 40px;
  overflow: hidden;
}

.scroll-content{
  position: relative;
  transition: top 0.5s;
  li{
    line-height: 40px;
    display: flex;
    align-items: center;
  }
}
</style>